import Page from '../../components/Page';
import * as React from "react";
import {useEffect} from "react";

import * as LogicService from "../../services/LogicService";
import {DOCUMENTS_DETAILS} from "../../services/LogicService";
import Foto_2 from "./images/cazier-online-constanta-2.jpg"
import Foto_3 from "./images/cazier-online-constanta-3.jpg"
import Foto_4 from "./images/cazier-online-constanta-4.jpg"
import Foto_5 from "./images/cazier-online-constanta-5.jpg"
import Foto_6 from "./images/cazier-online-constanta-6.jpg"
import Foto_cta from "./images/cazier-online-constanta-cta.jpg"
import * as Countries from "../../constants/Countries";
import "./style1.css"
import {Helmet} from "react-helmet-async";

export default function MainPageConstanta({browserDataCheck}) {

    useEffect(() => {
        browserDataCheck();
    }, []);

    let keywords = [
        "cazier judiciar online Constanta",
        "cazier Constanta online",
        "cazier judiciar Constanta online",
        "eliberare cazier online Constanta",
        "obtinere cazier judiciar online Constanta",
        "cazier judiciar online Constanta pret",
    ]

    return (
        <Page title={`Cazier online Constanța - Obține cazierul simplu, rapid și eficient`}>
            <Helmet>
                <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"/>
                <link rel="stylesheet"
                      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"/>
                <meta name="description"
                      content={"Aveți nevoie să obțineți urgent cazierul judiciar și sunteți din Constanța? Acum, puteți beneficia de un serviciu online eficient și rapid, perfect adaptat nevoilor dumneavoastră."}/>
                <meta name="keywords" content={keywords.join(',')}/>
                <title>Cazier online Constanța - Obține cazierul simplu, rapid și eficient</title>
            
            </Helmet>

            <div className="section" style={{backgroundColor: '#f8f8f8'}}>
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center padding-more">
                            <h1>Cazier online Constanța</h1>
                            <p style={{fontWeight: 'bold', color: '#00ab55'}}>Obține cazierul simplu, rapid și
                                eficient</p>
                            <p>Aveți nevoie să obțineți urgent cazierul judiciar și sunteți din Constanța? Acum, puteți
                                beneficia de un
                                serviciu online eficient și rapid, perfect adaptat nevoilor dumneavoastră.</p>
                            <p>Caziere.ro vă scutește de timpul pierdut la coadă la ghișee și vă oferă confortul
                                obținerii cazierului
                                online din Constanța fără a fi necesar să vă deplasați de acasă.</p>
                            <a href={window.location.origin}>
                                <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar
                                </button>
                            </a>
                        </div>


                        <div className="col-md-6 bg-image" style={{backgroundImage: `url(${Foto_2})`}}></div>
                    </div>
                </div>
            </div>


            <div className="cta" style={{backgroundImage: `url(${Foto_cta})`}}>
                <div className="container">
                    <h2>Obțineți simplu și repede cazierul judiciar online din Constanţa!</h2>
                    <a href={window.location.origin}>
                        <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar</button>
                    </a>
                </div>
            </div>


            <div className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Avantajele obținerii online a cazierului judiciar din județul Constanța</h2>
                            <p>Eliberarea cazierului judiciar din Constanţa, dar și din alte localități din țară, nu a
                                fost
                                niciodată mai simplă și mai accesibilă. Serviciul nostru online vă permite să obțineți
                                documentul
                                necesar într-un mod foarte confortabil. Avantajele obținerii online a cazierului
                                judiciar din
                                Constanța:
                            </p>

                            <ul className="checkmarkList">
                                <li dir="ltr" role="presentation">Economie de timp și efort
                                </li>
                                <li dir="ltr" aria-level="1">Procedură simplificată și rapidă
                                </li>
                                <li dir="ltr" aria-level="1">Asistență profesională la fiecare pas
                                </li>
                                <li dir="ltr" aria-level="1">Confidențialitatea și securitatea datelor personale
                                </li>
                                <li dir="ltr" aria-level="1">Livrarea flexibilă și promptă a documentului
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className="cta" style={{backgroundImage: `url(${Foto_cta})`}}>
                <div className="container">
                    <h2>Obțineți simplu și repede cazierul judiciar online din Constanţa!</h2>
                    <a href={window.location.origin}>
                        <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar</button>
                    </a>
                </div>
            </div>


            <div className="section" style={{backgroundColor: "#fbfbfb"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                            <h2>De ce să apelați la caziere.ro pentru a obține un cazier judiciar online din Constanța
                            </h2>
                            <p>Cu o experiență vastă în domeniu și o abordare axată pe nevoile clienților, serviciul
                                nostru online
                                vă facilitează obținerea cazierului judiciar din Constanța fără bătăi de cap și pierdere
                                de
                                timp. </p>

                            <p><strong>Vă prezentăm câteva motive pentru care suntem partenerul ideal în acest proces:
                            </strong></p>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-md-6 order-md-2">
                            <img src={Foto_3} alt="Cazier online Constanța" className="img-fluid"/>
                        </div>
                        <div className="col-md-6 order-md-1">
                            <ul className="checkmarkList">
                                <li dir="ltr" aria-level="1">Echipa noastră de specialiști este pregătită să gestioneze
                                    fiecare
                                    cerere cu cea mai mare atenție, asigurându-se că toate procedurile legale sunt
                                    respectate în
                                    vederea obținerii cazierului judiciar.
                                </li>
                                <li dir="ltr" aria-level="1">Înțelegem că fiecare solicitare este unică și importantă,
                                    motiv pentru
                                    care oferim asistență personalizată, fiind gata să vă răspundem la întrebări și să
                                    vă ghidăm
                                    prin întregul proces.
                                </li>
                                <li dir="ltr" aria-level="1">Știm că timpul este prețios pentru dumneavoastră, motiv
                                    pentru care vă
                                    facilităm obținerea cazierului judiciar din Constanța cât mai repede posibil, fără
                                    să
                                    compromitem acuratețea sau legalitatea acestuia.
                                </li>
                                <li dir="ltr" aria-level="1">Vă oferim încă de la început un calcul exact al
                                    cheltuielilor și nu
                                    veți avea surpriza costurilor ascunse sau a taxelor suplimentare neașteptate
                                </li>
                                <li dir="ltr" aria-level="1">Cu sistemul nostru de urmărire online, veți fi la curent cu
                                    fiecare
                                    etapă a procesului de obținere a cazierului judiciar, oferindu-vă liniștea că totul
                                    se
                                    desfășoară conform planului.
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row align-items-center" style={{paddingTop: '20px'}}>

                        <div className="col-md-12 order-md-1" style={{textAlign: 'center'}}>
                            <p>În concluzie, dacă sunteți din Constanța și aveți nevoie de un cazier judiciar online
                                rapid și fără
                                griji, caziere.ro este opțiunea la care puteți apela cu încredere.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="cta" style={{backgroundImage: `url(${Foto_cta})`}}>
                <div className="container">
                    <h2>Obțineți simplu și repede cazierul judiciar online din Constanţa!</h2>
                    <a href={window.location.origin}>
                        <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar</button>
                    </a>
                </div>
            </div>


            <div className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                            <h2>Situațiile în care poate fi necesară obținerea online a unui cazier din Constanța
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 order-md-1">
                            <img src={Foto_4} alt="Cazier online Constanța" className="img-fluid"/>
                        </div>
                        <div className="col-md-6 order-md-2">
                            <p>Obținerea unui certificat de cazier judiciar este o cerință comună în multe situații de
                                viață, de la
                                angajare până la tranzacții legale și internaționale. De exemplu, dacă aveți reședința
                                în Constanța
                                și vă pregătiți pentru un nou job, poate fi necesar să prezentați un cazier
                                judiciar.</p>
                            <p> De asemenea, pentru înscrierea la unele universități sau pentru procesul de obținere a
                                unei vize de
                                călătorie, autoritățile competente pot solicita acest document. </p>
                            <p>Prin serviciul online de eliberare a cazierului din Constanța, puteți obține rapid din
                                confortul
                                casei acest act important.</p>

                        </div>
                    </div>
                </div>
            </div>


            <div className="section" style={{paddingTop: '5px'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Actele necesare pentru obținerea cazierului judiciar în Constanța, online</h2>
                            <p>Serviciul online oferit de caziere.ro este deosebit de util. Prin simpla încărcare a unei
                                copii a
                                actului de identitate și a unei fotografii cu acesta, procesul de obținere online a
                                cazierului
                                judiciar din Constanța devine mult mai accesibil.</p>

                            <p>Contractul de prestări servicii este un alt document esențial pentru începerea
                                procedurilor, care
                                poate fi semnat online, conferind echipei de la caziere.ro împuternicirea legală de a
                                acționa în
                                numele dumneavoastră. Acesta asigură o colaborare transparentă și legală între
                                dumneavoastră și
                                serviciul oferit.</p>
                        </div>
                    </div>

                </div>
            </div>

            <div className="cta" style={{backgroundImage: `url(${Foto_cta})`}}>
                <div className="container">
                    <h2>Obțineți simplu și repede cazierul judiciar online din Constanţa!</h2>
                    <a href={window.location.origin}>
                        <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar</button>
                    </a>
                </div>
            </div>


            <div className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                            <h2>Etapele care trebuie parcurse pentru eliberarea unui cazier online în Constanța
                            </h2>
                            <p>Obținerea unui certificat de cazier judiciar online pentru cei cu reședința în Constanța
                                este acum un
                                proces simplificat și eficient, care elimină necesitatea deplasărilor la instituțiile
                                statului. Prin
                                intermediul platformei caziere.ro, puteți să obțineți cazierul judiciar rapid, fără a
                                pierde timp în
                                cozi și fără a vă îngrijora de complexitatea procedurilor.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 order-md-2">
                            <img src={Foto_5} alt="Cazier online Constanța" className="img-fluid"/>
                        </div>
                        <div className="col-md-6 order-md-1">
                            <p><strong>Pentru eliberarea cazierului online din Constanța, trebuie să urmați următorii
                                pași:</strong>
                            </p>
                            <ul className="checkmarkList">
                                <li dir="ltr" aria-level="1">Accesați platforma online caziere.ro și completați
                                    formularul cu
                                    informațiile solicitate;
                                </li>
                                <li dir="ltr" aria-level="1">Încărcați documentele necesare: copia actului de
                                    identitate, o
                                    fotografie cu dumneavoastră ținând actul în mână și contractul semnat digital prin
                                    care
                                    caziere.ro este împuternicit să acționeze în numele dumneavoastră;
                                </li>
                                <li dir="ltr" aria-level="1">Alegeți serviciul dorit și efectuați plata online prin card
                                    bancar sau
                                    transfer bancar tradițional;
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: '20px'}}>
                        <div className="col-md-12" style={{textAlign: 'center'}}>

                            <p>Veți fi notificat prin email și SMS despre stadiul comenzii și, odată finalizat, veți
                                primi cazierul
                                judiciar scanat, urmat de original prin curier rapid, indiferent de locația
                                dumneavoastră.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section" style={{paddingTop: '10px'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                            <h2>Durata emiterii certificatului de cazier judiciar online din Constanța
                            </h2>
                            <p>Obținerea unui certificat de cazier judiciar online pentru cei cu reședința în Constanța
                                se
                                realizează într-un interval de timp cuprins între 1-5 zile lucrătoare de la data la care
                                sunt
                                primite și semnate toate documentele necesare. În anumite situații, este posibil ca
                                acesta să fie
                                eliberat chiar în aceeași zi a solicitării. </p>

                            <p>Durata emiterii poate varia dacă sunt solicitate servicii suplimentare, cum ar fi
                                apostilarea sau
                                traducerea documentelor. Tot procesul se desfășoară rapid și eficient, astfel încât
                                solicitanții să
                                primească în cel mai scurt timp documentul de care au nevoie.</p>
                        </div>
                    </div>

                </div>
            </div>


            <div className="section" style={{backgroundColor: "#fbfbfb"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 order-md-1">
                            <img src={Foto_6} alt="Cazier online Constanța" className="img-fluid"/>
                        </div>
                        <div className="col-md-6 order-md-2">
                            <h2>Cazier judiciar online Constanța - preț</h2>
                            <p>Obținerea unui cazier judiciar online din Constanța acum este mai simplă și mai rapidă
                                decât oricând.
                                Prețul pentru acest serviciu este variabil și se calculează în funcție de o serie de
                                criterii
                                specifice nevoilor dumneavoastră. Factorii care influențează costul final al obținerii
                                cazierului
                                judiciar sunt:
                            </p>
                            <ul className="checkmarkList">
                                <li dir="ltr" aria-level="1">Tipul solicitantului: persoană fizică sau juridică;
                                </li>
                                <li dir="ltr" aria-level="1">Urgența eliberării: regim normal sau de urgență, cu opțiuni
                                    de
                                    eliberare într-o zi sau în 5 zile lucrătoare;
                                </li>
                                <li dir="ltr" aria-level="1">Servicii suplimentare: traducere legalizată în diferite
                                    limbi, cu sau
                                    fără apostila Haga;
                                </li>
                                <li>Modul de livrare: electronic prin email sau prin curier rapid la o adresă
                                    specificată.
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>


            <div className="cta" style={{backgroundImage: `url(${Foto_cta})`}}>
                <div className="container">
                    <h2>Obțineți simplu și repede cazierul judiciar online din Constanţa!</h2>
                    <a href={window.location.origin}>
                        <button><i className="fas fa-download custom-icon"></i> Obțineți cazier judiciar</button>
                    </a>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Aveți nevoie de un cazier juridic din Constanța? Apelați cu încredere la serviciile
                                noastre
                                online!</h2>
                            <p>Pentru orice nelămuriri sau detalii suplimentare despre obținerea unui cazier juridic
                                online din
                                județul Constanţa, echipa noastră este gata să vă asiste. Scrieți-ne la adresa <a
                                    href="mailto:contact@caziere.ro">contact@caziere.ro</a> și vă vom răspunde în cel
                                mai scurt
                                timp posibil.</p>

                            <p>Caziere.ro oferă o soluție simplă și eficientă pentru eliberarea cazierului judiciar
                                online, pentru
                                persoane fizice și juridice, economisind timp și efort și asigurând că tot procesul este
                                gestionat
                                cu profesionalism și atenție la detalii! Nu lăsați birocrația să vă încetinească
                                planurile și
                                apelați la serviciile noastre!</p>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}
